export default __webpack_public_path__ + "static/4. Streamlined Centre Operations Management 1-5947bb742b74a36e8fb531e200e9b0f5.jpg";